import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Popup} from '../../popup/Popup';
import {InsightPopupData} from './InsightPopupData';
import {InsightPopupService} from './insight-popup.service';
import {InsightTabs} from './InsightTabs';
import {Observable} from 'rxjs';
import {
    AuthUntilUserRoleService
} from '../../../../../../micromate-learn-web/src/app/core/authentication/auth-until-user-role.service';
import {
    ImpersonationService
} from '../../../../../../micromate-learn-web/src/app/core/authentication/impersonation.service';

@Component({
    selector: 'mm-insight-popup',
    templateUrl: './insight-popup.component.html',
    styleUrl: './insight-popup.component.scss',
    providers: [InsightPopupService],
    standalone: false
})
export class InsightPopupComponent implements Popup<InsightPopupData>, OnInit, OnDestroy {
    @Input()
    public data!: InsightPopupData;

    public isAdmin$: Observable<boolean>;

    constructor(public insightPopupService: InsightPopupService,
                private roleService: AuthUntilUserRoleService,
                public impersonationService: ImpersonationService,) {
        this.isAdmin$ = roleService.assertAdmin();
    }

    public ngOnInit(): void {
        this.insightPopupService.setTab(this.data.currentTab);
        this.insightPopupService.setStudyProgresses(this.data.studyProgress);
    }

    public ngOnDestroy(): void {
        this.insightPopupService.clearFeedbackDraft();
    }

    protected readonly InsightTabs = InsightTabs;
}
